<template>
  <v-app>
    <v-app-bar app color="red" dark dense flat>
      <v-toolbar-title>
        <v-icon small>far fa-exclamation-triangle</v-icon>&nbsp;
        รายละเอียดข้อผิดพลาด
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <div class="pa-4">
        <div class="title">CODE : {{ errCode }}</div>
        <div class="subtitle-1">SUB-CODE: {{ subErrCode }}</div>
        <v-divider class="my-4"></v-divider>
        <div v-text="desc"></div>

        <!-- <div class="pt-4">
          <v-btn color="primary">ออกจากแบบทดสอบ</v-btn>
        </div> -->
      </div>
    </v-main>
  </v-app>
</template>

<script>
import errors from "../assets/errors.json";
export default {
  data: () => ({
    errCode: "",
    subErrCode: "",
    desc: "",
    errors: errors,
  }),
  mounted() {
    let errCodeArr = this.$route.params.code.split(".");
    this.errCode = errCodeArr[0];
    if (errCodeArr.length > 1) {
      this.subErrCode = errCodeArr[1];
    }
    const err = this.errors.find(
      (w) => w.code == this.errCode && w.subCode == this.subErrCode
    );
    this.desc = err != null ? err.desc : "";
  },
};
</script>